import { render, staticRenderFns } from "./newBusiForm.vue?vue&type=template&id=b1f1aec0&scoped=true"
import script from "./newBusiForm.vue?vue&type=script&lang=js"
export * from "./newBusiForm.vue?vue&type=script&lang=js"
import style0 from "./newBusiForm.vue?vue&type=style&index=0&id=b1f1aec0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1f1aec0",
  null
  
)

export default component.exports